import React, { useEffect, useState } from 'react';
import Header from '../Header/Header';
import NewPost from '../NewPost/NewPost';
import './Profile.css';
import $ from 'jquery';
import CreateIcon from '@material-ui/icons/Create';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import SchoolIcon from '@material-ui/icons/School';
import FavoriteIcon from '@material-ui/icons/Favorite';
import RoomIcon from '@material-ui/icons/Room';
import HomeIcon from '@material-ui/icons/Home';
import CakeIcon from '@material-ui/icons/Cake';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import SendIcon from '@material-ui/icons/Send';
import {Modal } from 'semantic-ui-react';
import ClearIcon from '@material-ui/icons/Clear';
import CheckIcon from '@material-ui/icons/Check';
import ProgressBar from 'react-bootstrap/ProgressBar';
import IconButton from '@material-ui/core/IconButton';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import BackupIcon from '@material-ui/icons/Backup';
import { db, storage } from '../Auth/FirebaseConfig';
import { useParams } from 'react-router';
import { Button, Paper } from '@material-ui/core';
import Post from '../Post/Post';
import { Link } from 'react-router-dom';




const Profile = ({user}) => {
    const { userName } = useParams();
    const [profileUser, setProfileUser] = useState();
    const [fullProfileUser, setFullProfileUser] = useState();
    const [friends, setFriends] = useState();
    const [posts, setPosts] = useState([]);
    const [open, setOpen] = useState(false);
    const [progress, setProgress] = useState(0);
    const [bio, setBio] = useState('');
    const [profileURL, setProfileURL] = useState('');
    const [coverURL, setCoverURL] = useState('');
    const [study,setStudy]= useState();
    const [live, setLive]= useState();
    const [from,setFrom]= useState();
    const [status, setStatus] =  useState();




    useEffect(() => {
        db.collection('users').doc(userName).onSnapshot((doc) => {
            setProfileUser(doc.data());
            })
        },[userName]);
        //console.log(userName , user.displayName)

        useEffect(() => {
            db.collection('users').doc(userName).collection('fullProfile').doc('uid').onSnapshot((doc) => {
                setFullProfileUser((doc.data()))
            })
        },[userName]);

        useEffect(() => {
            db.collection('users').doc(profileUser?.displayName).collection('friends').onSnapshot((snapshot) => {
                setFriends(snapshot.docs.map(doc => doc.data()))
            })           
        },[profileUser?.displayName]);
       // console.log(friends?.friendName)
   

    useEffect(() => {
        db.collection('posts').onSnapshot(snapshot => {
            setPosts(snapshot.docs.map(doc => ({
                id: doc.id,
                post: doc.data(),
            })));
        })
    }, []);
   // console.log(  posts.map((post) => (post.post)))

    const addFriend = () => {
        db.collection('users').doc(user.displayName).collection('friends').doc(profileUser.displayName).set({
            friendName:profileUser.displayName,
            friendId:profileUser.uid || profileUser.proId,
            friendPhoto:profileUser.photoURL
        });
        db.collection('users').doc(profileUser.displayName).collection('friends').doc(user.displayName).set({
            friendName:user.displayName,
            friendId:user.uid || user.proId,
            friendPhoto:user.photoURL
        });          
    };
      
    const coverUpload = (event) => {
        $('.progBar')[0].style.display = 'block';
      event.preventDefault();
      const uploadTask = storage.ref(`coverImages/${user.uid}`).put(coverURL);
      uploadTask.on(
          "state_changed",
          (shot) => {
              const progress = Math.round(( shot.bytesTransferred / shot.totalBytes) * 100);
              setProgress(progress);
          }, (error) => {
              alert(error.message);
          }, () => {
              storage.ref("coverImages").child(user.uid).getDownloadURL()
                  .then(url => {
                      user.updateProfile({
                         
                      }).then( () => {
                          db.collection('users').doc(userName).collection('fullProfile').doc('uid').set({
                              coverPhoto: url
                          }).then( () => {
                              setProgress(0);
                              $('.progBar')[0].style.display = 'none';
                              $('.coverUpBtn')[0].style.display = 'none';
                          })
                      })
                  })
              }
          )
      };

    const profileUpload = (event) => {
          $('.progBar')[0].style.display = 'block';
        event.preventDefault();
        const uploadTask = storage.ref(`profileImages/${user.uid}`).put(profileURL);
        uploadTask.on(
            "state_changed",
            (shot) => {
                const progress = Math.round(( shot.bytesTransferred / shot.totalBytes) * 100);
                setProgress(progress);
            }, (error) => {
                alert(error.message);
            }, () => {
                storage.ref("profileImages").child(user.uid).getDownloadURL()
                    .then(url => {
                        user.updateProfile({
                            photoURL: url
                        }).then( () => {
                            db.collection('users').doc(userName).update({
                                photoURL: url
                            }).then( () => {
                                setProgress(0);
                                $('.progBar')[0].style.display = 'none';
                                $('.profileUpBtn')[0].style.display = 'none';
                            })
                        })
                    })
                 }
              )
          };
    const bioUpdate = () => {
            db.collection('users').doc(userName).update({
                bio: bio
            }).then(
                setOpen(false)
            )        
    };
    const introUpBtn = () => {
        $('.editIntro1')[0].style.display = 'block';
        $('.editIntro2')[0].style.display = 'block';
        $('.editIntro3')[0].style.display = 'block';
        $('.editIntro4')[0].style.display = 'block';
        $('.introUpBtn')[0].style.display = 'block';
        $('.editIntroBtn')[0].style.display = 'none';      
    };
    const introUpdate = () => {  
        db.collection('users').doc(userName).collection('fullProfile').doc('uid').set({           
            live,
           from,
           study,
           status
        }).then( () => {
            $('.editIntro1')[0].style.display = 'none';
            $('.editIntro2')[0].style.display = 'none';
            $('.editIntro3')[0].style.display = 'none';
            $('.editIntro4')[0].style.display = 'none';
            $('.introUpBtn')[0].style.display = 'none';
            $('.editIntroBtn')[0].style.display = 'block';
        })  
    };
    


    return (
        <div className="myProfile">
           <Header user={user} />
           <div className="headerBio">
                <div className="cover_photo">
                    <img src={fullProfileUser?.coverPhoto} alt="" />
                    {
                        userName === user.displayName ? (
                         <>   <input accept="image/*"  id="coverPhotoIcon" type="file" 
                            onChange={(e) => {  
                                $('.coverUpBtn')[0].style.display = 'block';
                                setCoverURL(e.target.files[0])}
                            } 
                            style={{display:'none'}}/>
                        <label htmlFor="coverPhotoIcon">
                            <IconButton color="primary" component="span" className="coverIcon">
                            <PhotoCamera />
                            </IconButton>
                        </label> </>
                        ) : ( console.log())
                    }
                   
                </div>
                <div className="face_photo">
                   <img  src={profileUser?.photoURL} alt=''/>
                   {
                    userName === user.displayName ? (
                     <>  <input accept="image/*"  id="profilePhotoIcon" type="file" 
                     onChange={(e) => {  
                         $('.profileUpBtn')[0].style.display = 'block';
                         setProfileURL(e.target.files[0])}
                     } 
                     style={{display:'none'}}/>
                     <label htmlFor="profilePhotoIcon">
                        <IconButton color="primary" component="span" className="profileIcon">
                     <PhotoCamera />
                     </IconButton>
                    </label> </>
                    ) : ( console.log())
                }
                </div>
                <div className="coverUpBtn">
                    <Button variant="contained" color="primary" startIcon={<BackupIcon />} onClick={coverUpload} >
                    Update Cover photo
                    </Button>
                </div>
                <div className="profileUpBtn">                
                  <Button variant="contained" color="primary" startIcon={<BackupIcon />} onClick={profileUpload} >
                    Update Profile photo
                 </Button>
                </div>
                <ProgressBar variant="info" now={progress} className="progBar mb-2 "/>
                <div className="myBio">
                    <h4>{profileUser?.displayName}</h4>
                    <p><Paper className="p-2">{profileUser?.bio}</Paper></p>  
                    {
                        userName === user.displayName ? (
                            <button  onClick={() => setOpen(true)}>Edit Bio</button>
                        ) : ( console.log())
                    }                 
                </div>
                <Modal open={open} onClose={() => setOpen(false)} onOpen={() => setOpen(true)} size="mini">
                <textarea value={bio} placeholder={profileUser?.bio} onChange={(e) => {setBio(e.target.value)}}/>
                    <p>{`${101 - bio.length} characters remaining`}</p>  
                    <Button variant="contained" color="primary" startIcon={<ClearIcon />} onClick={() => setOpen(false)}>
                    Cancel
                   </Button>
                   <Button variant="contained" color="primary" startIcon={<CheckIcon />} onClick={bioUpdate}>
                    Save
                   </Button>
                </Modal>

                <div className="profile_options pt-3">
                  <ul>
                    <li className="selected">Timeline</li>
                    <li>About</li>
                    <li>Friends</li>
                    <li>Photos</li>
                    <li>Archive</li>
                    <li>More</li>
                {
                    userName === user.displayName ? (
                        <>  
                        <Button variant="contained" color="primary" startIcon={<AddCircleIcon />} className="ml-3">
                            Add to Story
                        </Button>
                        <Button variant="contained"  startIcon={<CreateIcon />} className="ml-3">
                            Edit Profile
                        </Button>
                        </> 
                    ) : (    
                    // friends?.map((nm) => 
                    //   userName === nm   ? (
                    //     <> 
                    //     <Button variant="contained" color="primary" startIcon={<CheckIcon/>} className="ml-3" >
                    //          Friend
                    //     </Button>
                    //     <Button variant="contained"  startIcon={<SendIcon/>} className="ml-3">
                    //         Message
                    //     </Button> 
                    //     </> 
                    //      ) : (                                                            
                        <> 
                        <Button variant="contained" color="primary" startIcon={<GroupAddIcon/>} className="ml-3" onClick={addFriend}>
                            Add Friend
                        </Button>
                        <Button variant="contained"  startIcon={<SendIcon/>} className="ml-3">
                            Message
                        </Button> 
                        </>
                                
                        // )
                        // )
                    ) 
                }                            
                    <Button variant="contained"  startIcon={<MoreHorizIcon />} className="ml-3">                                
                    </Button>
                </ul>
                </div>
           </div>

           <div className="introPost row">
           <div className="introLeft m-3 ">
           <div className="introBio">
               <Paper className="py-2 px-3">
                   <h2>Intro</h2>
                   <p><CakeIcon fontSize="large"/> 
                         {`${profileUser?.birthday[0]} - ${profileUser?.birthday[1]} - ${profileUser?.birthday[2]}`}
                    </p>                  
                   <p><SchoolIcon fontSize="large"/> 
                        Study in {fullProfileUser?.study}  
                        <input type="text" placeholder={fullProfileUser?.study} className="editIntro1" 
                             value={study} onChange={(e) => setStudy(e.target.value)}/>
                    </p>
                   <p><HomeIcon fontSize="large"/>
                         Lived in {fullProfileUser?.live} 
                         <input type="text" placeholder={fullProfileUser?.live}  className="editIntro2" 
                              value={live} onChange={(e) => setLive(e.target.value)}/>
                    </p>
                   <p><RoomIcon fontSize="large"/> 
                        From {fullProfileUser?.from} 
                        <input type="text" placeholder={fullProfileUser?.from} className="editIntro3"
                            value={from} onChange={(e) => setFrom(e.target.value)}/>
                    </p>
                   <p><FavoriteIcon fontSize="large"/> 
                         {fullProfileUser?.status} 
                        <input type="text" placeholder={fullProfileUser?.status} className="editIntro4"
                            value={status} onChange={(e) => setStatus(e.target.value)}/>
                    </p>
                    <Button variant="contained" color="primary" startIcon={<CheckIcon />}
                             className="ml-5 w-75 introUpBtn" onClick={introUpdate}>
                          Save
                    </Button>
                {
                    userName === user.displayName ? (
                        <Button variant="contained" startIcon={<CreateIcon/>} 
                                className="ml-5 w-75 mb-2 editIntroBtn" onClick={introUpBtn} >
                           Edit Intro
                        </Button>
                    ) : ( console.log())
                }
               </Paper>
           </div>
           <div className="introBio">
                <Paper className="py-2 px-3">
                    <h2>Photos</h2>
                    {
                        posts.map((post) => (                            
                            post.post.proName === profileUser?.displayName ? ( 
                                !post.post.postImage ? (
                                    console.log()
                                    ) : ( <img key={post.post.postDate} src={post.post.postImage} alt="" className="introPhoto" />  )
                            ) : ( console.log()) 
                        ))
                    }                    
                </Paper>
           </div>
           <div className="introBio ">
                <Paper className="py-2 px-3 introFrnd">
                    <h2>Friends</h2>
                    {
                      friends?.map(frnd =>
                         <div className="mb-2">
                            <Link to={`/${frnd.friendName}`}>
                               <img src={frnd.friendPhoto} alt="" /> 
                               &nbsp;&nbsp;{frnd.friendName}
                            </Link>
                         </div> )
                    }
                </Paper>
             </div>  
           </div>
           
           <div className="introRight">
                {
                    userName === user.displayName ? (
                        <NewPost user={user}/>
                    ) : ( console.log())
                }
                {
                    posts.map(({ id, post }) => (
                        post.proName !== userName ? (
                            console.log()
                        ) : (
                            <Post key={id} postId={id} user={user} proName={post.proName} proImage={post.proImage} postDate={post.postDate}
                            postMessage={post.postMessage} postImage={post.postImage} noLikes={post.noLikes} postUserId={post.uid} />
                            )
                    ))
                }
           </div>
         </div>
            
        </div>
    );
};
export default Profile;